export const CookieSettingsLink = ({ testId, className = "" }) => (
  <a href="/cookie-settings" className={`underline underline-offset-4 transition-opacity hover:opacity-70 ${className}`} data-testid={testId}>Cookie settings</a>
);